
@if (control.enabled && !control.isReadOnly && !control.isLoading && control.isDirty && control.errors) {
    @let errorMessage = errors.GetMessage(control.errors);
    <div
        [attr.data-sb-qa]="qaTag"
        class="sb-form-field-error-wrapper">
        <lib-icon
            [size]="IconSize.ThreeExtraSmall"
            [icon]="Icon.Common.ErrorOutline"></lib-icon>
        <small>
            {{ errorMessage }}
        </small>
    </div>
}
